import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { LogoutCauses } from '../logout-causes';

@Component({
	selector: 'logout-expired',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

	private sub: Subscription;
	public cause: string;

	constructor( private route: ActivatedRoute ) {
	}

	ngOnInit() {
		this.sub = this.route.queryParams.subscribe( params => {
			this.cause = params['causa'];
			let values: string[] = Object.values( LogoutCauses );
			this.cause = values.includes( this.cause )? this.cause: LogoutCauses.Cancelled;
		});
	}

	ngOnDestroy() {
		this.sub.unsubscribe();
	}

}
